import styled from 'styled-components';
import { rem } from '@/styles/theme';

interface IAvatarProps {
  isActive?: boolean;
  theme: any;
  size?: string;
  bgColor?: string;
  portrait?: boolean;
}

export const AvatarSquare = styled.img<IAvatarProps>`
  box-sizing: border-box;
  background: ${({ bgColor }) => bgColor};
  ${({ isActive, theme, bgColor }) => {
    return `
        ${theme.avatarStyles.square}; 
        border: ${isActive ? `${rem(1.5)} solid ${theme.color['primary-100']}` : 'none'};
        background: ${isActive ? `${theme.color.white}` : `${bgColor}`};
      `;
  }}
  ${({ theme }) => theme.media.fold`
    width: ${rem(50)};
    height: ${rem(50)};
    border-radius: ${rem(16)};
  `}
`;
